import { DocumentStatus, Locale, LocalizedString } from '@synergy/models';
import { FormattedMessage } from 'react-intl';
import { PaloStatusPill } from '@synergy/components-palo';
import { ReactElement } from 'react';

/**
 * Whether a localized text is complete, and which languages are missing.
 *
 * Six configuration lists say this. Before they moved onto the shared list each
 * built its own chip, of a kind used nowhere else in the app; on the PALO scale
 * a complete text is a finished thing and an incomplete one is a draft.
 */
export const TranslationPill = ({
    value,
    locales,
}: {
    value?: LocalizedString | null;
    locales: Locale[];
}): ReactElement => {
    const missing = locales.filter(locale => !value?.[locale]);

    return (
        <PaloStatusPill
            status={0 === missing.length ? DocumentStatus.Completed : DocumentStatus.Created}
            label={
                0 === missing.length ? (
                    <FormattedMessage id="app.common.translated" />
                ) : (
                    <FormattedMessage id="app.common.missingTranslations" values={{ value: missing.join(', ') }} />
                )
            }
        />
    );
};
